document.documentElement.classList.remove('no-js');

document.addEventListener('click', event => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;

  const menu = document.querySelector('[data-menu]');
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  menu?.classList.toggle('is-open', !expanded);
});

document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-scroll-to-product]');
  if (!trigger) return;

  const form = document.querySelector('.product-form');
  if (!form) return;

  const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
  if (submitButton?.disabled) {
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit(submitButton || undefined);
  } else {
    form.submit();
  }
});

document.querySelectorAll('[data-product-section]').forEach(section => {
  const variantsScript = document.querySelector('[data-product-json]');
  if (!variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch {
    return;
  }

  const selectors = section.querySelectorAll('[data-option-selector]');
  const variantInput = section.querySelector('[data-variant-id]');
  const price = section.querySelector('[data-price]');

  const formatMoney = cents => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  };

  const updateVariant = () => {
    const selected = Array.from(selectors).map(select => select.value);
    const variant = variants.find(item => item.options.every((option, index) => option === selected[index]));
    if (!variant) return;

    variantInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);
  };

  selectors.forEach(select => select.addEventListener('change', updateVariant));
});

(function () {
  function activateElementAsLink(element, href, label) {
    if (!element || !href) return;

    if (element.tagName === 'A') {
      element.href = href;
      element.setAttribute('aria-label', label);
      return;
    }

    element.setAttribute('role', 'link');
    element.setAttribute('tabindex', '0');
    element.setAttribute('aria-label', label);
    element.style.cursor = 'pointer';

    element.addEventListener('click', event => {
      if (event.target.closest('a, button, input, select, textarea')) return;
      window.location.href = href;
    });

    element.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      window.location.href = href;
    });
  }

  function linkProductCardsToPrimaryAction() {
    document.querySelectorAll('.shopify-product-card, .product-card').forEach(card => {
      const primaryLink = card.querySelector('a.button.primary, a[href^="/products/"], a[href^="/cart/"]');
      const href = primaryLink?.getAttribute('href');
      if (!href) return;

      const productName = card.querySelector('h1, h2, h3')?.textContent?.trim()
        || card.querySelector('img')?.alt
        || 'Product';
      const label = productName + ' - View product';

      activateElementAsLink(card.querySelector('.shopify-product-media'), href, label);
      activateElementAsLink(card.querySelector('.product-image'), href, label);
      activateElementAsLink(card.querySelector('h2 a, h3 a'), href, label);
      activateElementAsLink(card.querySelector('h2, h3'), href, label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkProductCardsToPrimaryAction);
  } else {
    linkProductCardsToPrimaryAction();
  }
})();

(function () {
  const offer = 'Buy 2, get FREE shipping — use code 250USA at checkout.';
  const oneItemMessage = 'Add 1 more item, then use code 250USA for FREE shipping!';
  const qualifiedMessage = 'Add code 250USA at checkout for FREE shipping!';

  function cartItemCount() {
    let count = 0;
    document.querySelectorAll('.cart-item input[name="updates[]"]').forEach(input => {
      count += parseInt(input.value || '0', 10) || 0;
    });
    const headerCount = parseInt(document.querySelector('.header-cart-count')?.textContent || '0', 10) || 0;
    return count || headerCount;
  }

  function ensureCartNudge() {
    const cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;

    let nudge = document.querySelector('[data-cart-shipping-nudge]');
    if (!nudge) {
      nudge = document.createElement('div');
      nudge.className = 'cart-shipping-nudge';
      nudge.setAttribute('data-cart-shipping-nudge', '');
      cartForm.insertAdjacentElement('beforebegin', nudge);
    }

    const count = cartItemCount();
    if (count === 1) {
      nudge.textContent = oneItemMessage;
    } else if (count >= 2) {
      nudge.textContent = qualifiedMessage;
    } else {
      nudge.textContent = '';
    }
  }

  function addTrustBadges() {
    document.querySelectorAll('.shopify-product-card, .product-card, .bundle-panel, .bundle-card').forEach(container => {
      const button = container.querySelector('a.button.primary[href^="/cart/"], a.button.primary[href^="/products/"]');
      if (!button || container.querySelector('.purchase-trust-badges')) return;

      const badges = document.createElement('div');
      badges.className = 'purchase-trust-badges';
      badges.setAttribute('aria-label', 'Purchase reassurance');
      badges.innerHTML = '<span>Handcrafted in Cameron, TX</span><span>Made with organic ingredients</span><span>Buy 2, get FREE shipping — use code 250USA at checkout</span>';
      button.insertAdjacentElement('afterend', badges);
    });
  }

  function updateOfferCopy() {
    const announcement = document.querySelector('.announcement-bar');
    if (announcement) announcement.textContent = offer;

    document.querySelectorAll('.purchase-trust-badges span').forEach(span => {
      if (/shipping/i.test(span.textContent)) span.textContent = 'Buy 2, get FREE shipping — use code 250USA at checkout';
      if (/organic/i.test(span.textContent)) span.textContent = 'Made with organic ingredients';
    });

    addTrustBadges();
    ensureCartNudge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateOfferCopy);
  } else {
    updateOfferCopy();
  }

  document.addEventListener('change', event => {
    if (event.target.matches('.cart-item input[name="updates[]"]')) ensureCartNudge();
  });
})();
